// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles */
.search-tips::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 20px;
    border-width: 0 10px 10px 10px;
    border-style: solid;
    border-color: transparent transparent var(--primary) transparent;
}

.custom-default-home-tips {
    position: relative;

    ul {
        width: 95% !important;
        list-style: decimal !important;

        li {
            list-style: decimal !important;
        }
    }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/TabsLayout/components/DefaultHomeIconTutorialComponent/DefaultHomeIconTutorialComponent.css"],"names":[],"mappings":"AAAA,WAAW;AACX;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,8BAA8B;IAC9B,mBAAmB;IACnB,gEAAgE;AACpE;;AAEA;IACI,kBAAkB;;IAElB;QACI,qBAAqB;QACrB,8BAA8B;;QAE9B;YACI,8BAA8B;QAClC;IACJ;AACJ","sourcesContent":["/* Styles */\n.search-tips::before {\n    content: '';\n    position: absolute;\n    top: -10px;\n    left: 20px;\n    border-width: 0 10px 10px 10px;\n    border-style: solid;\n    border-color: transparent transparent var(--primary) transparent;\n}\n\n.custom-default-home-tips {\n    position: relative;\n\n    ul {\n        width: 95% !important;\n        list-style: decimal !important;\n\n        li {\n            list-style: decimal !important;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
